import { UsdCell } from '@siliconx/shared/ui/UsdCell';

/**
 * D8: a server with no System FMV contributes the sum of its priced
 * components to portfolio value. That number is an estimate, so it is
 * labelled wherever it is shown.
 */
export function FmvCell({
  value,
  estimatedFromComponents,
}: {
  value: number | null;
  estimatedFromComponents: boolean;
}) {
  return (
    <span className="inline-flex flex-col items-end">
      <UsdCell value={value} />
      {estimatedFromComponents && value !== null && (
        <span
          className="text-xs text-zinc-500"
          title="This server has no System FMV yet. The value is the sum of its priced components."
        >
          est. from components
        </span>
      )}
    </span>
  );
}
